import $ from 'jquery';

$(function(){
    $('.pcd-select').on('change', function(e) {
        var $this = $(this),
            val = '',
            $target = $this.closest('.pcd-block').find('.pcd-value');
        if ($this.val()) {
            val = $this.val() + ' mm.';
        }
        $target.text(val);
    });
});



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/info.js
 **/